import { Col, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const SlamDunkImg = styled.img`
  width: ${(props) => (props.isMobile ? 266 : 400)}px;

  ${(props) =>
    props.isMobile &&
    `
    height: 227px;
    object-fit: cover;
  `}
`;

const AthleteImg = styled.img`
  width: ${(props) => (props.isMobile ? 266 : 440)}px;

  ${(props) =>
    props.isMobile &&
    `
    height: 227px;
    object-fit: cover;
  `}
`;

const Banner = (props) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col wid="100%" marg={isMobile ? '0' : '34px 0 0'}>
      {!isMobile && (
        <Col wid="1140px" ht="100%" center>
          <Text lineHt="30px" size="20px">
            {t('website.athleteZoneSmall')}
          </Text>
        </Col>
      )}

      <Col
        noFlex
        wid="100%"
        ht={isMobile ? '124px' : '316px'}
        bg={theme.GREEN}
        marg={isMobile ? '23px 0 0' : '24px 0 0'}
      >
        <Col wid={isMobile ? '100vw' : '1140px'} ht="100%" center pos="relative">
          {!isMobile && (
            <Col
              pos="absolute"
              noFlex
              wid={isMobile ? '100vw' : '550px'}
              ht={isMobile ? '184px' : '334px'}
              bg="#000"
              bottom={isMobile ? '-184px' : '-48px'}
            />
          )}

          <Col
            pos="absolute"
            left={isMobile ? '-140px' : '260px'}
            top={isMobile ? '-21px' : '-49px'}
          >
            <SlamDunkImg isMobile={isMobile} src={require('assets/images/slam-dunk.png')} />
          </Col>

          <Col pos="absolute" right="0" top={isMobile ? '-21px' : '-26px'}>
            <AthleteImg isMobile={isMobile} src={require('assets/images/athlete-image.jpg')} />
          </Col>

          <Col pos="absolute" left={isMobile ? '16px' : '0'} top={isMobile ? '166px' : '118px'}>
            <Text
              stencil
              col="#fff"
              size={isMobile ? '85px' : '167px'}
              lineHt={isMobile ? '30px' : '50px'}
              marg="0 0 0 -12px"
              style={{
                letterSpacing: isMobile ? '-8px' : '-12px'
              }}
            >
              {t('website.ledBy')}
            </Text>

            <Text
              stencil
              col="#fff"
              size={isMobile ? '85px' : '167px'}
              marg={isMobile ? '0 0 0 10px' : '0 0 0 29px'}
              style={{
                letterSpacing: isMobile ? '-6px' : '-12px'
              }}
            >
              {t('website.athletes.')}
            </Text>
          </Col>
        </Col>
      </Col>

      {isMobile && (
        <Col
          noFlex
          wid={isMobile ? '100vw' : '550px'}
          ht={isMobile ? '184px' : '334px'}
          bg="#000"
        />
      )}
    </Col>
  );
};

export default Banner;
